module.exports = __webpack_public_path__ + "img/personalCenter.56975b14.png";